import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";

export const ErrorContainer = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  height: 500px;
`;

export const ErrorTitle = styled.h2`
  font-size: 32px;
  color: #000;
  font-weight: bold;
`;

export const ErrorLink = styled(LinkR)`
  font-size: 24px;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  border: solid 1px transparent;
  color: #2f5;
  background-color: #000;
  font-weight: bold;
  &:hover {
    background-color: #2f5;
    color: #000;
    text-decoration: underline;
    border: solid 1px #000;
  }
`;
